import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider, App as AntdApp } from 'antd';
import tr_TR from 'antd/lib/locale/tr_TR';
import store, { persistor } from './store/configureStore'
import './localization'
import './index.css';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <ConfigProvider 
    locale={tr_TR} 
    wave={{ disabled: true }}
    theme={{
      token: {
        colorPrimary: '#c41617',
      },
    }}
  >
    <AntdApp>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </AntdApp>
  </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();